import React, { FC, ReactNode } from 'react';
import { Input } from 'snacks-design-system';
/* https://snacks.takeaway.com/portal/components/input/ */

interface IPIEInput {
  onChange: (e: any) => void;
  onBlur: (e: any) => void;
  onFocust: () => void;
  actionElement: ReactNode;
  leadingIcon: ReactNode;
  trailingIcon: ReactNode;
  trailingLabel: string;
  leadingIconProps: {
    modreturnfocus: boolean;
    onClick: () => void;
    onKeydown: () => void;
    onKeyup: () => void;
    onMuseDown: () => void;
    onTouchStart: () => void;
    onTouchEnd: () => void;
  };
  trailingIconProps: {
    onClick: () => void;
    onKeydown: () => void;
    onKeyup: () => void;
    onMuseDown: () => void;
    onTouchStart: () => void;
    onTouchEnd: () => void;
  };
  modRound: boolean;
  modPreventScrollOnfFocus: boolean;
  modErrorVissualyHidden: boolean;
  showTextLimitMessage: boolean;
  showErrorContainer: boolean;
  showLabelContainer: boolean;
  size: 'small' | 'medium' | 'large';
  hint: string;
  inputMode:
    | 'text'
    | 'decimal'
    | 'email'
    | 'none'
    | 'numeric'
    | 'search'
    | 'tel'
    | 'url';
  readonly: boolean;
  autoComplete: string;
  autoFocus: string;
  disabled: boolean;
  error: boolean | ReactNode;
  value: string;
  label: string;
  placeholder: string;
  hideLEadingIconIfEmpty: boolean;
  hideTrailingIconIfEmpty: boolean;
  maxlength: number;
}

export const PIEInput: FC<Partial<IPIEInput>> = (props) => {
  return (
    <div>
      <Input {...props} />
    </div>
  );
};

export default PIEInput;
